import ajax from '@/utils/ajax';

const header = '/web';

// 获取日签图
export const getSignImage = async () => {
  const { data } = await ajax(`${header}/v1/word/sign-in-manage/current`);
  return data;
};

// 获取长难句总结
export const getStudyInfo = async () => {
  const { data } = await ajax(`${header}/v1/user-sentence/statistics/data`);
  return data;
};

// 获取单词总结
export const getWordInfo = async ({ date, userBookId }) => {
  const { data } = await ajax(`${header}/v1/word/user-sign?date=${date}&userBookId=${userBookId}`);
  return data;
};

// 获取长难句圈子总结
export const getLongCircleInfo = async (id) => {
  const { data } = await ajax(`${header}/v1/user-checkin-circle/info?circleId=${id}`);
  return data;
};
